export default __webpack_public_path__ + "static/media/1.012f392c.png";